module.exports = __webpack_public_path__ + "media/images/howitworks1-37249f4ba8ea5825ea661fbfdeb58efa.png";